import { RelatedProducts } from "./app.related-products.js";

var DEBOUNCE_MS = 500;

var cart_recs_default = (() => {
    if (customElements.get("cart-recs")) return;
    customElements.define("cart-recs", class CartRecs extends RelatedProducts {
        constructor() {
            super();
            this._drawerOpen = false;
            this._debounceTimer = null;
            this._savingBatch = false;
            this._onLockerChange = this._onLockerChange.bind(this);
            this._onCartUpdated = this._onCartUpdated.bind(this);
            this._onCartAdded = this._onCartAdded.bind(this);
            this._onSaveStart = this._onSaveStart.bind(this);
            this._onSaveEnd = this._onSaveEnd.bind(this);
            this._onItemError = this._onItemError.bind(this);
        }
        connectedCallback() {
            super.connectedCallback();
            this.checkbox = document.getElementById("Cart");
            this._drawerOpen = Boolean(this.checkbox?.checked);
            this.checkbox?.addEventListener("change", this._onLockerChange);
            document.addEventListener("cart:updated", this._onCartUpdated);
            document.addEventListener("cart:added", this._onCartAdded);
            document.addEventListener("cart:save-start", this._onSaveStart);
            document.addEventListener("cart:save-end", this._onSaveEnd);
            document.addEventListener("cart-item:error", this._onItemError);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.checkbox?.removeEventListener("change", this._onLockerChange);
            document.removeEventListener("cart:updated", this._onCartUpdated);
            document.removeEventListener("cart:added", this._onCartAdded);
            document.removeEventListener("cart:save-start", this._onSaveStart);
            document.removeEventListener("cart:save-end", this._onSaveEnd);
            document.removeEventListener("cart-item:error", this._onItemError);
            clearTimeout(this._debounceTimer);
        }
        _onLockerChange() {
            this._drawerOpen = Boolean(this.checkbox?.checked);
            if (!this._drawerOpen) return;
            this.setSource(this.dataset.sourceProduct);
            this.removeAttribute("data-stale");
        }
        _onCartAdded(event) {
            if (this._savingBatch) return;
            this._syncSource(event.detail?.cart?.items?.[0]?.product_id);
        }
        _onCartUpdated(event) {
            if (this._savingBatch) return;
            this._syncSource(event.detail?.cart?.items?.[0]?.product_id);
        }
        _onSaveStart() {
            this._savingBatch = true;
            clearTimeout(this._debounceTimer);
        }
        _onSaveEnd(event) {
            this._savingBatch = false;
            this._syncSource(event.detail?.cart?.items?.[0]?.product_id);
        }
        _onItemError() {
            this._savingBatch = false;
        }
        _syncSource(sourceId) {
            this.style.display = sourceId ? "" : "none";
            if (!sourceId) return;
            if (this.dataset.sourceProduct === String(sourceId)) return;
            this.dataset.sourceProduct = String(sourceId);
            if (!this._drawerOpen) {
                this.setAttribute("data-stale", "true");
                return;
            }
            clearTimeout(this._debounceTimer);
            this._debounceTimer = setTimeout(() => {
                if (!this._drawerOpen) {
                    this.setAttribute("data-stale", "true");
                    return;
                }
                this.setSource(this.dataset.sourceProduct);
                this.removeAttribute("data-stale");
            }, DEBOUNCE_MS);
        }
    });
})();